import { render, staticRenderFns } from "./xray.vue?vue&type=template&id=5bc4df60&scoped=true"
import script from "./xray.vue?vue&type=script&lang=js"
export * from "./xray.vue?vue&type=script&lang=js"
import style0 from "./xray.vue?vue&type=style&index=0&id=5bc4df60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4df60",
  null
  
)

export default component.exports